import {observer} from 'mobx-react';
import React from 'react';
import {Modal, ModalBody, ModalFooter} from 'reactstrap';
import {ModalMessageComponentStore} from './ModalMessageComponentStore';

@observer
export class ModalMessageComponent extends React.Component {
  store: ModalMessageComponentStore;

  constructor(props: any) {
    super(props);
    this.store = new ModalMessageComponentStore();
  }

  render() {
    const store = this.store;
    const message = store.message!;

    if (message === null)
      return null;

    if (message.modalType === 'prompt')
      return (
        <Modal isOpen={store.isOpen}
               toggle={store.close}
               size="md"
               centered
               onClosed={store.onModalClosed}>
          <ModalBody>
            {message.message}
          </ModalBody>
          <ModalFooter>
            <button type="button" className="btn btn-danger"
                    onClick={store.confirm}>
              {message.confirmLabel}
            </button>
            <button type="button" className="btn btn-primary"
                    onClick={store.cancel}>
              {message.cancelLabel}
            </button>
          </ModalFooter>
        </Modal>);

    return null;
  }

  componentWillUnmount() {
    this.store.dispose();
  }
}
